import type EnType from '../en-US/apiRunnerSplitPane';

export default {
  'apiRunnerSplitPane.request': 'Editor de Solicitud',
  'apiRunnerSplitPane.response': 'Respuesta',
  'apiRunnerSplitPane.vertical': 'Dividir Verticalmente',
  'apiRunnerSplitPane.horizontal': 'Dividir Horizontalmente',
  'apiRunnerSplitPane.none': 'Sin División',
} satisfies typeof EnType;
